<template>
  <div class="shipping-methods">
    <h4>Shipping Method</h4>
    <v-alert outline color="info" icon="info" :value="true">
      Business Days are the carrier's estimated time in transit to deliver your order after it ships.<br/>
      Select a USPS Shipping Method for PO Box deliveries.
    </v-alert>
    {{ address }}
    <v-form v-if="!!address && shippingMethods > 0"
            ref="shippingMethodForm"
            v-model="valid"
            lazy-validation>
      <v-radio-group :rules="requiredRules" validate-on-blur>
        <template v-for='method in shippingMethods'>
          <v-layout row v-if="showTitle(method.service)">
            <v-flex xs12>
              <h4 class="right">Shipping &amp; Processing</h4>
              <h4>{{method.service}}</h4>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6>
              <v-radio :label="method.name" :value="method.code"></v-radio>
            </v-flex>
            <v-flex xs6 right-align>
              {{method.rate | currency}}
            </v-flex>
          </v-layout>
        </template>
      </v-radio-group>
    </v-form>

    <div v-else class="loading center-align pt-5 pb-5">
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular><br>
      Loading Shipping Methods...
    </div>
  </div>
</template>

<script>
import api from '@/api/gungho'

export default {
  props: {
    shippingMethod: String,
    address: Object,
    item: Object
  },

  data () {
    return {
      valid: false,
      shippingMethods: [],
      requiredRules: [
        v => !!v || 'Cannot be blank'
      ]
    }
  },

  beforeMount () {
    this.loadShippingMethods()
    console.log('shipping methods')
  },

  watch: {
    valid: 'saveShippingMethod',
    address: 'loadShippingMethods'
  },

  methods: {
    saveShippingMethod () {
      if (this.$refs.shippingMethodForm.validate()) {
        this.$emit('save-shipping-method', this.shippingMethod)
      }
    },

    loadShippingMethods () {
      console.log('Load shipping methods')
      if (!this.address.valid) return
      if (!this.item.id) return

      api.shippingMethods(this.address, [this.item.id]).then(data => {
        console.log('Loaded Shipping Methods')
        this.shippingMethods = data.shipping_methods
      }).catch(error => {
        console.log(error)
      })
    },

    showTitle (service) {
      if (service === window.lastService) return false
      window.lastService = service
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// shipping-methods.vue?55376636